/**
 * 布局/视口指标快照，供 DBG 浮窗 useSyncExternalStore 订阅（排查左侧滚动区被撑高等）。
 */

export type LayoutBoxSlice = {
  id: string;
  clientWidth: number;
  clientHeight: number;
  scrollWidth: number;
  scrollHeight: number;
  offsetWidth: number;
  offsetHeight: number;
  scrollTop: number;
  scrollLeft: number;
};

/** 门店营收监控页：各层容器/左栏分区/AI 区尺寸（供 DBG 浮窗展示与复制） */
export type StoreRevenueMonitorLayoutSlices = {
  root?: LayoutBoxSlice;
  body?: LayoutBoxSlice;
  /** 含 padding 的 #root 子树（常为 Layout Content 外包一层） */
  appShell?: LayoutBoxSlice;
  /** .store-revenue-monitor-container */
  monitorContainer?: LayoutBoxSlice;
  /** .ant-splitter 根 */
  splitter?: LayoutBoxSlice;
  /** 左栏 ant-splitter-panel */
  leftPanel?: LayoutBoxSlice;
  /** .store-revenue-monitor-left-inner */
  leftInner?: LayoutBoxSlice;
  /** 统计卡片外包 */
  statCards?: LayoutBoxSlice;
  /** 搜索区外包 */
  searchWrap?: LayoutBoxSlice;
  /** .store-revenue-monitor-list-host */
  listHost?: LayoutBoxSlice;
  /** 门店列表滚动区 */
  listScroll?: LayoutBoxSlice;
  /** 右栏 ant-splitter-panel */
  rightPanel?: LayoutBoxSlice;
  /** 包裹 CompsAi 的 flex 容器 */
  aiWrap?: LayoutBoxSlice;
};

export type LayoutDebugData = {
  ts: string;
  path: string;
  windowInner: { width: number; height: number; dpr: number };
  documentElement: { clientWidth: number; clientHeight: number };
  /** 可选：Chrome performance.memory */
  memory?: { usedJSHeapSize?: number; totalJSHeapSize?: number; jsHeapSizeLimit?: number };
  leftScroll?: LayoutBoxSlice;
  storeContent?: LayoutBoxSlice;
  /** 门店营收监控多节点布局采样（与单店页的 leftScroll/storeContent 二选一展示） */
  revenueMonitor?: StoreRevenueMonitorLayoutSlices;
};

export type LayoutDebugSnapshot =
  | { kind: "empty" }
  | { kind: "ready"; data: LayoutDebugData };

let snapshot: LayoutDebugSnapshot = { kind: "empty" };
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((fn) => fn());
}

export function setLayoutDebugData(data: LayoutDebugData | null): void {
  snapshot = data ? { kind: "ready", data } : { kind: "empty" };
  notify();
}

export function subscribeLayoutDebug(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function getLayoutDebugSnapshot(): LayoutDebugSnapshot {
  return snapshot;
}

export function sliceElement(el: HTMLElement, id: string): LayoutBoxSlice {
  return {
    id,
    clientWidth: el.clientWidth,
    clientHeight: el.clientHeight,
    scrollWidth: el.scrollWidth,
    scrollHeight: el.scrollHeight,
    offsetWidth: el.offsetWidth,
    offsetHeight: el.offsetHeight,
    scrollTop: el.scrollTop,
    scrollLeft: el.scrollLeft,
  };
}
